require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./features-invoicing-and-payments.json") })
        }
      }, "path---features-invoicing-and-payments");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---features-invoicing-and-payments!./.cache/json/features-invoicing-and-payments.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---features-invoicing-and-payments!./.cache/json/features-invoicing-and-payments.json
// module chunks = 231608221292675